<template>
    <div style="width:1024px;" v-if="quoteData" color="white" class="mr-1">
      <ctlQuoteDoc :quoteData="quoteData"></ctlQuoteDoc>

    </div>
</template>
<script>
import ctlQuoteDoc from "@/components/ctlQuoteDoc.vue";

import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    'ctlQuoteDoc': ctlQuoteDoc
  },
  data: () => ({
    quoteData: null,
  }),
  computed: {
    ...mapGetters("auth", ["loggedIn"]),
    id() {
      return this.$route.params.id;
    },
    error() {
      return this.$store.getters.error;
    }
  },
  watch: {},
  methods: {
      ...mapActions('pubQuoteEdit', [
          'populateQuoteEditDataForInternalRep',
      ]),
      async loadQuoteData() {
        this.quoteData = await this.populateQuoteEditDataForInternalRep(this.id)

      },
      onDismissed() {
    }
  },
  created: async function() {
    // if (this.initQuoteData) {
    //   this.quoteData = Object.assign({}, this.initQuoteData)
    // } else {
      
    //   }
    await this.loadQuoteData()
  },
  mounted: function() {
    //Start the conversion. Note that this is only necessary 
    //when HtmlToPdf.Options.TriggerMode is set Manual or Dual.
    //The default value is Auto, so the conversion starts 
    //automatically.
    //You may also use variable "eoapi" to check whether the page
    //is running inside the converter so that the custom triggering
    //code will not run inside a regular browser because variable
    //"eoapi" does not exist in a regular browser
    // if (window.eoapi && eoapi.isEOPdf())
    //     eoapi.convert();
  },
  destroyed: function() {
    this.onDismissed();
  }
};
</script>